import React, { ComponentType } from 'react';
import Auth from 'works/legacy/lib/auth';
import {
  setActiveMenu,
  setActiveSecondaryMenu,
} from 'works/legacy/lib/client-store';
import { FourZeroFourPage } from '@identity/pages';
import { Navigate } from '@common/components';

export const PrivateRoute = ({
  page: Page,
  onRender = () => {},
  menuItem,
  secondaryMenuItem = null,
  permitted = true,
}: {
  page: ComponentType;
  onRender?: () => void;
  menuItem?: string | null;
  secondaryMenuItem?: string | null;
  permitted?: boolean;
}) => {
  setActiveMenu(menuItem);
  setActiveSecondaryMenu(secondaryMenuItem);

  if (!Auth.signedIn()) {
    // Requires a hard refresh so that a new and valid
    // csrf token is fetched from the rails headers.
    return <Navigate to="/works/sign_in" />;
  }

  if (!permitted) {
    return <FourZeroFourPage />;
  }

  onRender();

  return <Page />;
};
